module.exports = __webpack_public_path__ + "img/normal_user.8bc8dcdc.png";